import { render, staticRenderFns } from "./BroadcastList.vue?vue&type=template&id=a90d5bd6&scoped=true&"
import script from "./BroadcastList.vue?vue&type=script&lang=js&"
export * from "./BroadcastList.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastList.vue?vue&type=style&index=0&id=a90d5bd6&prod&scoped=true&lang=css&"
import style1 from "./BroadcastList.vue?vue&type=style&index=1&id=a90d5bd6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90d5bd6",
  null
  
)

export default component.exports